import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { PlaceholderWrapper, PlaceholderBody, PlaceholderFooter } from '.';
import PlaceholderImage from './shipping-box.svg';
import { PATH_ENHANCED_RETURNS, STATUS_PENDING_APPROVAL, useEnhancedReturnRouteMatch } from '../../../../../store/returns/returns.helpers';
import { SsrSignOnButton } from '../../../../settings/stores/selected-store/returns-tab/ssr-sign-on-button';

import messages from './messages';

export const NoCompletedReturnsPlaceholder = () => {
  const intl = useIntl();
  const history = useHistory();
  const { storeGuid } = useEnhancedReturnRouteMatch();
  const onGoToPendingApproval = useCallback(() => {
    history.push(`${PATH_ENHANCED_RETURNS}/${storeGuid}/${STATUS_PENDING_APPROVAL}`);
  }, [history, storeGuid]);

  return (
    <PlaceholderWrapper>
      <img alt={intl.formatMessage(messages.noReturnsAltText)} src={PlaceholderImage} />
      <PlaceholderBody>
        <Text textType={TextType.H2} value={messages.noCompletedReturnsHeader} />
        <Text textType={TextType.Paragraph} value={messages.noCompletedReturnsDescription} />
      </PlaceholderBody>
      <PlaceholderFooter>
        <Button onClick={onGoToPendingApproval} theme='primary'>
          <FormattedMessage {...messages.goToPendingApproval} />
        </Button>
        <SsrSignOnButton
          label={<FormattedMessage {...messages.configureReturnSettings} />}
          shouldShowIcon={false}
          storeGuid={storeGuid}
          theme='secondary'
        />
      </PlaceholderFooter>
    </PlaceholderWrapper>
  );
};
